import React from 'react'
import { servicesImages, specImages } from '../../../config'

const SpecialtiesSection = () => {
  return (
    <div>
         <section className="bg-primary py-16 text-white">
        <div className="container mx-auto text-center">
          <h3 className="text-4xl font-bold mb-8">Our Specialties</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="hover:scale-105 transform transition">
              <img
                src={servicesImages.arthritis}
                alt="Physiotherapy"
                className="mx-auto px-4 mb-4 lg:px-0"
              />
             <h4 className="text-xl font-semibold">Physiotherapy</h4>
            </div>
            <div className="hover:scale-105 transform transition">
              <img
                src={specImages.chiropracticOne}
                alt="Chiropractic Care"
                className="mx-auto px-4  mb-4 lg:px-0"
              />
             <h4 className="text-xl font-semibold">Chiropractic Care</h4>
            </div>
            <div className="hover:scale-105 transform transition">
              <img
                src={servicesImages.headaches}
                alt="Acupuncture"
                className="mx-auto px-4  mb-4 lg:px-0"
              />
             <h4 className="text-xl font-semibold">Acupuncture</h4>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default SpecialtiesSection